var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawnChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74659 28.14C5.60155 28.1839 5.45138 28.2085 5.29992 28.2133C5.10938 28.2125 4.92089 28.174 4.74526 28.1C4.56964 28.0261 4.41036 27.9182 4.27655 27.7826C4.14275 27.6469 4.03706 27.4861 3.96556 27.3095C3.89407 27.1329 3.85817 26.9439 3.85992 26.7533C3.85925 26.5666 3.89541 26.3816 3.96633 26.2089C4.03726 26.0361 4.14156 25.8791 4.27326 25.7467L14.0733 15.94L16.0733 17.94L10.6333 23.4067L18.8466 20.74L21.1266 23.0267L5.74659 28.14ZM27.7799 27.6267C27.5123 27.8873 27.1535 28.0332 26.7799 28.0332C26.4064 28.0332 26.0476 27.8873 25.7799 27.6267L4.43992 6.28668C4.1694 6.01704 4.01708 5.65099 4.01645 5.26904C4.01583 4.88709 4.16695 4.52053 4.43659 4.25001C4.70623 3.97949 5.07229 3.82717 5.45423 3.82654C5.83618 3.82591 6.20274 3.97704 6.47326 4.24668L27.8066 25.54C28.0672 25.8076 28.2131 26.1665 28.2131 26.54C28.2131 26.9136 28.0672 27.2724 27.8066 27.54V27.5933L27.7799 27.6267ZM27.4399 20.88L24.1666 21.9533L21.8866 19.6733L26.5533 18.14C26.8938 18.0558 27.2533 18.0988 27.5644 18.261C27.8755 18.4231 28.1167 18.6932 28.2427 19.0206C28.3687 19.3479 28.3709 19.71 28.2489 20.0389C28.1269 20.3678 27.889 20.6408 27.5799 20.8067L27.4399 20.88Z",
    fill: "#F4D5C0",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawnChair);
export default __webpack_public_path__ + "static/media/LawnChair.2b6440788350402819f2732073bc5cbb.svg";
export { ForwardRef as ReactComponent };